import React from "react"
import { ArrowSubmitButton, BackArrow, ReimbursementDialogFraming } from "../shared/layouts"
import { Progress } from "#/components/views/modal/Progress"
import { useStateMachine } from "#/components/context/stateMachine/StateMachineV2"
import { useReimbursementContext } from "#/components/context/reimbursement/GetReimbursedContext"
import { FormattedMessage, useIntl } from "react-intl"
import { Box, DialogContentText, DialogTitle, Link } from "@carrotfertility/carotene-core"
import { DialogActionsBar, Form, FormRadioGroup } from "@carrotfertility/carotene-core-x"

export const ObgynIuiCycleCount = (): JSX.Element => {
  const { send, back } = useStateMachine()
  const intl = useIntl()

  const { state, updateObgynIuiCycleCount } = useReimbursementContext()

  const canSubmit = state.obgynIuiCycleCount != null

  const handleContinueClick = (): void => {
    send("")
  }

  const goBack = (): void => {
    updateObgynIuiCycleCount(null)
    back()
  }

  return (
    <>
      <Progress
        numSteps={3}
        step={2}
        label={intl.formatMessage({ defaultMessage: "OB/GYN IUI Cycle Count" })}
        inactiveStepBackgroundColor="#DBE6EE"
      />
      <BackArrow onClick={goBack} />
      <ReimbursementDialogFraming>
        <DialogTitle>
          <FormattedMessage defaultMessage="Including this one, how many IUI cycles have you had with an OB/GYN?" />
        </DialogTitle>
        <Box sx={{ display: "flex", flexDirection: "column", gap: (theme) => theme.tokens.spacing.lg }}>
          <DialogContentText>
            <FormattedMessage
              defaultMessage="We cover a maximum of four IUI cycles with an OB/GYN. See your
            <link>benefit guide</link> for more information. If this is your fifth cycle or more, please do not submit
            this expense."
              values={{
                link: (linkContent) => (
                  <Link target="_blank" href={"/your-benefit-guide/coverage/fertility-care"} color="inherit">
                    {linkContent}
                  </Link>
                )
              }}
            />
          </DialogContentText>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              alignItems: { xs: "flex-start", md: "center" }
            }}
          >
            <Form onSubmit={() => null}>
              <FormRadioGroup
                aria-labelledby="step-heading"
                name="obgynIuiCycleCount"
                controllerProps={{ rules: { required: intl.formatMessage({ defaultMessage: "Required" }) } }}
                options={[
                  { label: intl.formatMessage({ defaultMessage: "1" }), value: "1" },
                  { label: intl.formatMessage({ defaultMessage: "2" }), value: "2" },
                  { label: intl.formatMessage({ defaultMessage: "3" }), value: "3" },
                  { label: intl.formatMessage({ defaultMessage: "4" }), value: "4" }
                ]}
                onChange={(e) => {
                  updateObgynIuiCycleCount(parseInt((e.target as HTMLInputElement).value, 10))
                }}
              />
            </Form>
          </Box>
        </Box>
      </ReimbursementDialogFraming>
      <DialogActionsBar
        primaryAction={
          <ArrowSubmitButton enabled={canSubmit} onClick={handleContinueClick}>
            <FormattedMessage defaultMessage="Continue" />
          </ArrowSubmitButton>
        }
      />
    </>
  )
}
